import { styled } from "@mui/material/styles";

export const BreadCrumbsContainer = styled("div")(({ theme }) => ({
  borderBottom: "rgba(255,255,255,.1) 1px solid",
  padding: "0.75rem 2rem",
  "& ol": {
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    gap: "5px",
    "& li": {
      fontSize: "12px",
      opacity: ".6",
      position: "relative",
      "& .home-icon": {
        width: "13px",
        height: "13px",
        position: "relative",
        top: "2px",
      },
      "&:last-child": {
        opacity: 1,
      },
      "& a": {
        color: "#fff",
        textDecoration: "none",
      },
    },
  },
}));
